export function disableScrollToNumbInputs() {
  document.addEventListener("wheel", function(event){
    if(document.activeElement.type === "number"){
        document.activeElement.blur();
        // console.log('убрали скролл с инпута с численным значением')
    }
  })
}